module.exports = __webpack_public_path__ + "img/logo_new.12c9739a.svg";